import { render } from "./BaseInputCheckbox.vue?vue&type=template&id=40b3d48b&scoped=true&ts=true&lang=pug"
import script from "./BaseInputCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseInputCheckbox.vue?vue&type=script&lang=ts"

import "./BaseInputCheckbox.vue?vue&type=style&index=0&id=40b3d48b&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b3d48b"]])

export default __exports__